<ng-container [ngSwitch]="offersStatus$ | async">
  <fin-bound-selection-error-message
    class="block grow--min fill grey-25-bg pr-xsmall-t"
    *ngSwitchCase="AirOffersStatus.ERROR"
    [ctaButtonText]="'bookingSearch.tryAgain' | finLocalization"
    (ctaClick)="refetchOffers.emit()"
  >
    <span class="title">{{ 'bookingSearch.errors.fetchFailed' | finLocalization }}</span>
  </fin-bound-selection-error-message>

  <fin-bound-selection-error-message
    class="block grow--min fill grey-25-bg pr-xsmall-t"
    *ngSwitchCase="AirOffersStatus.NO_FLIGHTS_FOUND"
    [ctaButtonText]="'bookingSearch.pickNewDates' | finLocalization"
    (ctaClick)="backToDateSelection()"
  >
    <span class="title">{{ 'bookingSearch.errors.noFlightsFound' | finLocalization }}</span>
  </fin-bound-selection-error-message>

  <fin-bound-selection-error-message
    class="block grow--min fill grey-25-bg pr-xsmall-t"
    *ngSwitchCase="AirOffersStatus.INVALID_INPUT"
    [ctaButtonText]="'bookingSearch.pickNewDates' | finLocalization"
    (ctaClick)="backToDateSelection()"
  >
    <span class="title">{{ 'bookingSearch.errors.invalidInput' | finLocalization }}</span>
  </fin-bound-selection-error-message>

  <div class="fill grow--min grey-25-bg flex flex--column flex--center" *ngSwitchDefault>
    <fin-loader class="font-body-1" [type]="LoaderType.EMBEDDED" [title]="'ticketSelection.loading'"></fin-loader>
  </div>
  <div class="grey-25-bg" *ngSwitchCase="AirOffersStatus.OK">
    <ng-container *ngIf="selectionPhase$ | async as phase">
      <fin-ticket-selection-header
        [isOneWay$]="isOneWayOffers$"
        [departureDate$]="departureDate$"
        [returnDate$]="returnDate$"
        [outbound$]="$any(selectedOutbound$)"
        [inbound$]="$any(selectedInbound$)"
        [paxAmount$]="paxAmount$"
        [currencyCode$]="currencyCode$"
        [selectionPhase$]="selectionPhase$"
        [tripLocations]="tripLocations$ | async"
        (showDetails)="showDetailsModal($any($event[0]), $any($event[1]), phase)"
        (clickOutbound)="goToSelectionPhase(SelectionPhase.OUTBOUND)"
        (clickInbound)="goToSelectionPhase(SelectionPhase.INBOUND)"
      ></fin-ticket-selection-header>
    </ng-container>

    <div class="mobile-bleed" *ngIf="selectionPhase$ | async as phase">
      <fin-cabin-class-modal [cabinClasses$]="availableCabinClasses$"></fin-cabin-class-modal>

      <fin-bound-selection-list
        *ngIf="phase === SelectionPhase.OUTBOUND"
        [currencyCode$]="currencyCode$"
        [boundType]="BoundType.outbound"
        [selectionPhase]="SelectionPhase.OUTBOUND"
        [selectedSortBy$]="selectedSortBy$"
        [enabledBoundIds$]="enabledOutboundIds$"
        [cheapestCombinablePrices$]="cheapestCombinableOutboundPrices$"
        [bounds$]="outbounds$"
        [showFlightSelectionFilters]="showOutboundFilters$ | async"
        [filteredOffers$]="outboundSorting$"
        [boundIdSortOrder$]="outboundIdSortOrder$"
        [selectedBound$]="$any(selectedOutbound$)"
        [selectedFareFamilyCode$]="selectedOutboundFareFamilyCode$"
        [locations$]="locations$"
        [isMobile$]="isMobile$"
        [profile$]="profile$"
        [isLoading]="isLoading$ | async"
        (showDetails)="showDetailsModal($any($event), null, phase)"
        (openBound)="handleBoundOpen($any($event), BoundType.outbound)"
        (selectBound)="selectOutbound($any($event))"
        (selectFareFamily)="selectOutboundFareFamily($event)"
        (showBenefits)="handleShowBenefits($event)"
        (selectSortBy)="selectSortBy($event)"
        (showSpinner)="onShowSpinner()"
      >
      </fin-bound-selection-list>

      <fin-bound-selection-list
        *ngIf="phase === SelectionPhase.INBOUND"
        [currencyCode$]="currencyCode$"
        [boundType]="BoundType.inbound"
        [selectionPhase]="SelectionPhase.INBOUND"
        [selectedSortBy$]="selectedSortBy$"
        [enabledBoundIds$]="enabledInboundIds$"
        [filteredOffers$]="inboundSorting$"
        [cheapestCombinablePrices$]="cheapestCombinableInboundPrices$"
        [bounds$]="inbounds$"
        [showFlightSelectionFilters]="showInboundFilters$ | async"
        [boundIdSortOrder$]="inboundIdSortOrder$"
        [selectedBound$]="$any(selectedInbound$)"
        [selectedFareFamilyCode$]="selectedInboundFareFamilyCode$"
        [locations$]="locations$"
        [isMobile$]="isMobile$"
        [selectedOutbound$]="$any(selectedOutbound$)"
        [profile$]="profile$"
        [isLoading]="isLoading$ | async"
        (showDetails)="showDetailsModal(null, $any($event), phase)"
        (openBound)="handleBoundOpen($any($event), BoundType.inbound)"
        (selectBound)="selectInbound($any($event))"
        (selectFareFamily)="selectInboundFareFamily($event)"
        (showBenefits)="handleShowBenefits($event)"
        (selectSortBy)="selectSortBy($event)"
        (showSpinner)="onShowSpinner()"
      >
      </fin-bound-selection-list>
    </div>
  </div>
</ng-container>

<fcom-cta-button
  data-testid="award-ticket-selection-view-continue-cta-button"
  testid="continue-cta-button"
  [visible]="continueEnabled$ | async"
  [title]="'actions.next' | finLocalization"
  [position]="ButtonPosition.GRID_FULL"
  [disabled]="(continueEnabled$ | async) === false"
  (buttonClicked)="onContinueClick($event)"
>
  <span class="gray-50-text" data-testid="cta-price-label">{{ 'price.continueButtonTotal' | finLocalization }}: </span>
  <span *ngIf="selectedOfferPoints$ | async as points" class="font-body-1" data-testid="ticket-selection-cta-points">
    {{ 'award.points' | finLocalization: { pointsAmount: points || 0 | finPoints } }}&nbsp;+&nbsp;</span
  >
  <span class="font-body-1" data-testid="ticket-selection-cta-price">{{
    selectedOfferPrice$ | async | finPrice | finEmpty: '&ndash;'
  }}</span>
</fcom-cta-button>

<fcom-modal
  class="itinerary-modal"
  [title]="'itinerary.title' | finLocalization"
  [buttons]="ModalButtons.DONE"
  [open]="itineraryModal.open"
  (close)="closeModals()"
>
  <fin-itinerary
    *ngIf="itineraryModal.data.outbound || itineraryModal.data.inbound"
    class="block pr-medium"
    [outbound$]="itineraryModal.data.outbound | finToObservable"
    [inbound$]="itineraryModal.data.inbound | finToObservable"
    [selectionPhase$]="selectionPhase$"
    [locations$]="locations$"
    [isBookingFlow]="true"
  >
  </fin-itinerary>
</fcom-modal>

<fcom-modal
  class="benefits-modal"
  [title]="'fareFamilyDetails.title' | finLocalization"
  [buttons]="ModalButtons.DONE"
  [open]="benefitsModal.open"
  (close)="closeModals()"
  data-benefits-modal
>
  <fin-fare-family-details-v2
    *ngIf="benefitsModal.data"
    class="block"
    [splitByClasses]="false"
    [dimensionsAndDetails$]="benefitsModal.data | finToObservable"
    [showKoreaNotification]="showKoreaNotification$ | async"
  >
  </fin-fare-family-details-v2>
</fcom-modal>

<fcom-modal
  class="continue-modal"
  [title]="'modal.genericTitle' | finLocalization"
  [buttons]="ModalButtons.CONTINUE_CANCEL"
  [open]="continueModal.open"
  (confirm)="continueToNextStep()"
  (close)="closeModals()"
>
  <div class="pr-large" [class.highlighted-content]="showKoreaNotification$ | async" *ngIf="continueModal.data">
    <cms-unstyled-fragment
      *ngIf="continueModal.data.zeroBaggage"
      [contentUrl$]="'fragments.noBaggageWarning.url' | finLocalization | finToObservable"
      [showIcon]="true"
      class="fragment-inside-modal pr-medium-b block"
    ></cms-unstyled-fragment>
  </div>
</fcom-modal>
